import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

import logo from '../../logo.svg';

// Komponen Kartu Statistik Pemain
const PlayerStatCard = ({ title, value, icon }) => (
  <div className="bg-brand-gray p-4 rounded-xl border border-brand-terracotta/20 text-center transform hover:-translate-y-1 transition-transform duration-300">
    <i className={`fa-solid ${icon} text-brand-lime text-3xl mb-2`}></i>
    <p className="text-4xl font-bold text-white">{value}</p>
    <p className="text-gray-400 text-sm">{title}</p>
  </div>
);

// Komponen Riwayat Pertandingan
const MatchHistoryItem = ({ opponent, result, score, date }) => {
  const resultColor = result === 'Menang' ? 'text-brand-lime' : 'text-brand-terracotta';

  return (
    <div className="flex items-center justify-between p-4 bg-brand-gray/50 rounded-lg mb-3 hover:bg-brand-gray/80 transition-colors duration-200">
      <div>
        <p className="font-semibold text-white">vs {opponent}</p>
        <p className={`text-sm font-bold ${resultColor}`}>{result}</p>
      </div>
      <div className="text-right">
        <p className="font-mono text-white text-lg">{score}</p>
        <p className="text-xs text-gray-500">{date}</p>
      </div>
    </div>
  );
};

const DashboardPage = () => {
  const { user, phoneNumber } = useAuth();

  // Data dummy untuk statistik dan riwayat pertandingan
  const playerStats = {
    matchesPlayed: 0,
    wins: 0,
    losses: 0,
    xp: 0,
    coins: 0,
  };

  /* const matchHistory = [
    { opponent: 'Andi & Budi', result: 'Menang', score: '6-4, 6-3', date: '20 Okt 2025' },
    { opponent: 'Candra & Dedi', result: 'Kalah', score: '3-6, 7-5, 4-6', date: '18 Okt 2025' },
    { opponent: 'Eka & Fajar', result: 'Menang', score: '7-5, 6-1', date: '15 Okt 2025' },
    { opponent: 'Gita & Hari', result: 'Menang', score: '6-2, 6-2', date: '12 Okt 2025' },
  ]; */

  const matchHistory = [];

  const player = {
    rank: 1,
    name: phoneNumber || 'Pemain',
    points: 2350,
    avatar: `https://i.pravatar.cc/150?u=${user?.uid}`,
  };

  return (
    <div className="text-white min-h-screen bg-brand-dark p-4 md:p-8">
      <div className="max-w-4xl mx-auto">
        {/* Header Sambutan */}
        <div className="text-center mb-10">
          <Link to="/">
            <img src={logo} alt="SOCIAL DE PADEL Logo" className="mx-auto max-w-[150px] mb-8" />
          </Link>
          <h1 className="text-3xl font-bold text-white">Selamat Datang, {player.name}!</h1>
          <p className="text-gray-400 mt-2">Siap untuk permainan berikutnya?</p>
        </div>

        {/* Grid Statistik Pemain */}
        <div className="grid grid-cols-3 gap-4 mb-10">
          <div>
            <PlayerStatCard title="Main" value={playerStats.matchesPlayed} icon="fa-handshake" />
          </div>
          <div>
            <PlayerStatCard title="XP" value={playerStats.xp} icon="fa-star" />
          </div>
          <div>
            <PlayerStatCard title="Coin" value={playerStats.coins} icon="fa-coins" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;
